import {
  ACTIVE_PAYMENT_PROVIDER,
  PaymentProvider,
} from "@greenflagdate/shared";
import { authorizeNetClientAdapter } from "./authorizenet/adapter";
import { stripeClientAdapter } from "./stripe/adapter";
import { PaymentClientAdapter } from "./types";

export * from "./types";

/**
 * The browser half of the payment adapters. Adding a processor is a line here
 * plus a directory, mirroring packages/api/src/lib/payments/index.ts.
 *
 * Both halves read the same ACTIVE_PAYMENT_PROVIDER constant, so the client
 * cannot mint a token the server will not accept — except from a native build
 * that predates a switch, which the API rejects with PAYMENT_PROVIDER_MISMATCH.
 */
export const clientAdapters: Partial<
  Record<PaymentProvider, PaymentClientAdapter>
> = {
  [PaymentProvider.AuthorizeNet]: authorizeNetClientAdapter,
  [PaymentProvider.Stripe]: stripeClientAdapter,
};

export const activeClientAdapter = (): PaymentClientAdapter => {
  const adapter = clientAdapters[ACTIVE_PAYMENT_PROVIDER];
  if (!adapter) {
    throw new Error(
      `No payment client adapter for provider: ${ACTIVE_PAYMENT_PROVIDER}`
    );
  }
  return adapter;
};
